import React, { useEffect } from 'react';

type SeoProps = {
  title: string;
  description?: string;
};

function upsertMetaTag(attrName: 'name' | 'property', key: string, content: string) {
  let el = document.querySelector(`meta[${attrName}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export const Seo: React.FC<SeoProps> = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
    if (description) {
      upsertMetaTag('name', 'description', description);
      upsertMetaTag('property', 'og:title', title);
      upsertMetaTag('property', 'og:description', description);
    }
  }, [title, description]);

  return null;
};
